import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  selector: '[libAutocompleteContent]',
  standalone: true,
})
export class AutocompleteContentDirective {
  tpl = inject(TemplateRef);
}
